import React, { FunctionComponent } from "react";

import { FontIcon, Stack, Text, TooltipHost } from "@bps/fluent-ui";

interface FieldLabelWithInfoProps {
  label: string;
  info: string;
}

export const FieldLabelWithInfo: FunctionComponent<FieldLabelWithInfoProps> = ({
  label,
  info
}) => (
  <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 4 }}>
    <Text variant="medium" styles={{ root: { fontWeight: 600 } }}>
      {label}
    </Text>
    <TooltipHost content={info}>
      <FontIcon
        iconName="Info"
        styles={{ root: { fontSize: 14, cursor: "help" } }}
      />
    </TooltipHost>
  </Stack>
);
